var map = {
	"./certificate_automatic_frame.png": 227,
	"./certificate_ects_frame.png": 228,
	"./certificate_frame.png": 229,
	"./certificate_verified_frame.png": 230,
	"./frame_blue_de.png": 231,
	"./frame_blue_en.png": 232,
	"./frame_gold_de.png": 233,
	"./frame_gold_en.png": 234,
	"./frame_green_de.png": 235,
	"./frame_green_en.png": 236,
	"./generic_audit_sample.jpg": 237,
	"./generic_bundle_sample.jpg": 238,
	"./generic_coa_ects_sample.jpg": 239,
	"./generic_coa_sample.jpg": 240,
	"./generic_sop_sample.jpg": 241,
	"./milestone_completed.png": 242,
	"./milestone_completed.svg": 243,
	"./milestone_completed_small.svg": 244,
	"./milestone_uncompleted.png": 245,
	"./milestone_uncompleted.svg": 246,
	"./milestone_uncompleted_old.png": 247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 226;